import { blockOfflineAction } from '@/shared/utils';
import SDK from './core';

export const connect = async (username, password, isUnique) => {
   return await SDK.connect(username, password, isUnique);
};
export const register = async (
   userIdentifier,
   forceRegister = false,
   registerMetaData = {},
   domain = '',
   deepLink = '',
) => {
   return await SDK.register(userIdentifier, forceRegister, registerMetaData, domain, deepLink);
};

export const logout = async () => {
   if (!blockOfflineAction()) {
      return await SDK.logout();
   }
};
export const initializeSDK = async config => {
   return await SDK.initializeSDK(config);
};
export const disconnect = async () => await SDK.disconnect();
export const closeConnection = async () => await SDK.closeConnection();
export const generateQrCode = async (divId, logoId, host, callback) =>
   await SDK.generateQrCode(divId, logoId, host, callback);
